<template>
    <div class="loading_container" :style="containerStyle">
        <div class="spinner-border" role="status" :style="spinnerStyle">
            <span class="visually-hidden">{{ $t('common.loading') }}</span>
        </div>
        <template v-if="displayText">
            <br>
            <br>
            <h2 class="doto">{{ displayText }}</h2>
        </template>
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner',
    props: {
        text: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'md',
            validator: (value) => ['sm', 'md', 'lg'].includes(value)
        },
        inline: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        displayText() {
            return this.text || this.$t('common.loading')
        },
        containerStyle() {
            if (this.inline) {
                return {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                }
            }
            return {
                textAlign: 'center',
                margin: '5rem'
            }
        },
        spinnerStyle() {
            const sizes = {
                sm: { height: '0.75rem', width: '0.75rem' },
                md: { height: '1rem', width: '1rem' },
                lg: { height: '1.5rem', width: '1.5rem' }
            }
            return sizes[this.size]
        }
    }
}
</script>

<style scoped>
.loading_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.loading_container h2 {
    margin: 0;
}
</style>
